import type { LegendLayerItem } from './layoutTypes';

export function legendItemsForLayers(
  layers: readonly LegendLayerItem[],
  visibleIds: ReadonlySet<string>,
  restrictToIds?: readonly string[],
): LegendLayerItem[] {
  const allowed = restrictToIds ? new Set(restrictToIds) : null;
  return layers.filter((layer) => {
    if (!visibleIds.has(layer.id)) return false;
    if (allowed && !allowed.has(layer.id)) return false;
    return true;
  });
}
